// extracted by mini-css-extract-plugin
export var layoutContainer = "_dv-0";
export var layoutContainerNoRounding = "_dv-6";
export var layoutContainerOpen = "_dv-5";
export var layoutContainerResizing = "_dv-1";
export var mainContent = "_dv-2";
export var resizeDivider = "_dv-3";
export var slidePanel = "_dv-4";